import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import GenericAddButton from 'widgets/GenericAddButton/GenericAddButton';
import SearchIcon from '@mui/icons-material/Search';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

// Función para definir estilos
const getStyles = () => ({
  errorText: {
    color: 'red',
    textAlign: 'center',
  },
});

const SearchForm = ({ handleSubmit, handleSearch, errors, register, errorMessage }) => {
  // Obtén los estilos
  const styles = getStyles();
  const [currentDate, setCurrentDate] = useState('');

  useEffect(() => {
    const today = new Date().toISOString();
    const todayMexico = convertToMexicoTime(today);
    setCurrentDate(todayMexico.split(' ')[0]);
  }, []);

  return (
    <form onSubmit={handleSubmit(handleSearch)}>
      <Grid container spacing={2} alignItems='center'>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }}>
          <TextField
            label='Fecha'
            type='date'
            {...register('date')}
            error={Boolean(errors.date)}
            helperText={errors.date ? 'Introduzca una fecha válida.' : ''}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }}>
          <TextField
            label='Email'
            {...register('email', {
              pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            })}
            error={Boolean(errors.email)}
            helperText={errors.email ? 'introduzca un correo electrónico válido.' : ''}
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }}>
          <TextField
            label='Teléfono'
            {...register('phone', { pattern: /^\d{10}$/ })}
            error={Boolean(errors.phone)}
            helperText={errors.phone ? 'introduzca un número de teléfono válido.' : ''}
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }}>
          <TextField
            label='Nombre'
            {...register('name', {
              minLength: 3,
              pattern: {
                value: /^[a-zA-ZÀ-ÿ\s'-]+$/,
                message: 'Solo se permiten letras',
              },
            })}
            error={Boolean(errors.name)}
            helperText={errors.name ? 'introduzca un nombre con al menos 3 letras.' : ''}
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }}>
          <FormControl fullWidth>
            <InputLabel id='status-label'>Status</InputLabel>
            <Select labelId='status-label' {...register('status')} defaultValue=''>
              <MenuItem value='Pendiente'>Pendiente</MenuItem>
              <MenuItem value='Procesado'>Procesado</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }}>
          <GenericAddButton
            buttonText='Buscar'
            backgroundColor='#4C2484'
            size='medium'
            isSubmit
            icon={<SearchIcon />}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          {errorMessage && <p style={styles.errorText}>{errorMessage}</p>}
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchForm;
